import { useNavigate } from 'react-router-dom';

import { BsPauseCircle } from 'react-icons/bs';

import AppBanner from '#globalComponents/AppBanner/AppBanner';
import { BILLING_SETTINGS_PATH } from '#lib/constants/routes';
import { formatDate } from '#lib/dateUtils';
import { useBillingStatus } from '#settingsFeature/hooks/useBillingStatus';

// Not dismissable: it is the only explanation for why gated features refuse during a pause.
const SubscriptionStatusBanner = () => {
	const { isPaused, pause, isOwner } = useBillingStatus();
	const navigate = useNavigate();

	if (!isPaused) return null;

	const untilText = pause?.resumesAt ? `bis ${formatDate(pause.resumesAt)} ` : '';

	return (
		<AppBanner
			tone="primary"
			icon={BsPauseCircle}
			action={isOwner ? { label: 'Jetzt fortsetzen', onClick: () => navigate(BILLING_SETTINGS_PATH) } : undefined}
		>
			Ihr Abonnement ist {untilText}
			<strong>pausiert</strong> – Daten sichtbar, Lead-Recherche, Versand und Export deaktiviert.
		</AppBanner>
	);
};

export default SubscriptionStatusBanner;
